<template>
<div class="chapter">
<div class="inner_page">
<section class="" data-pdf-bookmark="Title Page" data-titlepage="yes" data-type="titlepage" epub:type="titlepage"><div class="preface" id="d1e63"><h1 class="ChapTitleNonprintingctnp">Title Page</h1><img class="titlepage" src="epubtitlepage.jpg"/></div></section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// titlepage01.vue?1377c908